import React, { useEffect } from "react";
import { Icon } from "../../UIElements/Icon";

const Modal = ({
  isOpen,
  onClose,
  title,
  subtitle,
  children,
  maxWidth = "max-w-2xl",
  showCloseButton = true,
  closeOnBackdrop = true,
  className = "",
}) => {
  useEffect(() => {
    if (!isOpen) return;

    const handleEscapeKey = (e) => {
      if (e.key === "Escape") {
        onClose();
      }
    };

    document.addEventListener("keydown", handleEscapeKey);

    return () => {
      document.removeEventListener("keydown", handleEscapeKey);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const handleBackdropClick = (e) => {
    if (closeOnBackdrop && e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-0 sm:p-4"
      onClick={handleBackdropClick}
    >
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby={title ? "modal-title" : undefined}
        className={`h-full w-full bg-gray-900 sm:h-auto sm:w-full sm:rounded-lg ${maxWidth} overflow-y-auto border-0 border-gray-800 sm:max-h-[90vh] sm:border ${className}`}
      >
        {/* Header */}
        {(title || subtitle || showCloseButton) && (
          <div className="flex items-start justify-between border-b border-gray-800 p-4 sm:p-6">
            <div className="min-w-0 flex-1 pr-2">
              {title && (
                <h2
                  id="modal-title"
                  className="truncate text-lg font-bold text-white sm:text-2xl sm:text-xl"
                >
                  {title}
                </h2>
              )}
              {subtitle && (
                <p className="mt-1 text-sm text-gray-400 sm:text-base">
                  {subtitle}
                </p>
              )}
            </div>
            {showCloseButton && (
              <button
                onClick={onClose}
                className="flex-shrink-0 text-gray-400 transition-colors hover:text-white"
              >
                <Icon name="X" className="h-5 w-5 sm:h-6 sm:w-6" />
              </button>
            )}
          </div>
        )}

        {/* Content */}
        <div className="p-4 sm:p-6">{children}</div>
      </div>
    </div>
  );
};

export default Modal;
